import React from 'react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import './Item.css';
var defaultProps = {};
export default function Item(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
Item.defaultProps = defaultProps;